import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";

const VisitorTracker = () => {
  const location = useLocation();

  useEffect(() => {
    // Ignore admin routes
    if (location.pathname.startsWith("/admin")) return;

    axios.post(
      `${process.env.REACT_APP_API_URL}/analytics/track`
    ).catch((err) => {
      console.error("Visitor tracking failed:", err);
    });

  }, [location.pathname]);

  return null;
};

export default VisitorTracker;
